import { twMerge } from 'tailwind-merge'
import { Button } from '@highlight/ui'
import { useIsMiniContentHovered } from '../atoms'
import { useIsMiniAnchoredLeft } from '../components/mini/side-context'

export function AudioNoteSavingButton() {
  const isContentHovered = useIsMiniContentHovered()
  const isAnchoredLeft = useIsMiniAnchoredLeft()

  return (
    <Button
      variant="ghost"
      size="sm"
      loading
      className={twMerge('px-2', !isContentHovered && (isAnchoredLeft ? 'mr-0.5' : 'ml-0.5'))}
    >
      Saving…
    </Button>
  )
}
